webClient.controller('B2B.accountController', ['$scope', '$window', '$timeout', '$i18next', '$http', 'tseApiClient', 'tseAirResultsHelper',
    function ($scope, $window, $timeout, $i18next, $http, tseApiClient, airHelper) {
        $scope.getText = function (key) { return $window.culture.texts[key]; };

        //RestApi client object
        var apiClient = tseApiClient.createClient($window.site.apiUrl, $window.site.apiUrlSSL);
        //apiClient.enableDebug();    //Only for debugging....
        window.airHelper = airHelper;

        //Set the current login information
        $scope.loginInfo = $window.site.loginInfo;
        $scope.clientId = $scope.loginInfo.Client.AccountNumber;
        $scope.paymentMode = $scope.loginInfo.Client.PaymentMode;
        $scope.loginId = $scope.loginInfo.LoginId;
        $scope.bookingRequest = {};
        //Put back default dates to avoid stressing the database
        $scope.bookingRequest.fromDate = moment().subtract(7, 'days').format('DD/MM/YYYY');
        $scope.bookingRequest.toDate = moment().format('DD/MM/YYYY');
        $scope.enableOption = $window.enableOption && !($window.sessionStorage.getItem('forceUpsell') === 'true' || $window.getUrlVars()['upsell'] === 'true');
        $scope.pendingPayment = false;
        $scope.currentCabinClass = null;
        $scope.isCrossFaring = false;
        $scope.enableBrandedFares = $window.enableBrandedFares;
        $scope.enableContactForm = $window.enableContactForm;
        $scope.enableBlockAgencyRemarks = $window.enableBlockAgencyRemarks;
        $scope.productType = window.sessionStorage.getItem('selectedProductType') || 'flight';
        $scope.ignoreProductType = false;
        $scope.hideSpecialRequest = $window.enableSpecialRequest && $window.specialRequestAccountNumbers.length > 0 ? !$window.specialRequestAccountNumbers.includes($window.site.loginInfo.Client.AccountNumber) : true;

        $scope.dateType = 1;
        $scope.showDetail = false;

        $scope.paxType = {};
        $scope.paxType["ADT"] = "Adulte";
        $scope.paxType["CNN"] = "Enfant";
        $scope.paxType["INF"] = "Bébé";
        $scope.hotelOnly = false; //flag used to hide/show html elements

        //****************Simple Payment Module ***********************************************
        $scope.paymentSimpleModule = function (paymentId) {
            $window.FLoading({ vAction: 'show' });
            $("#i-form").attr("action", "../airSimplePaymentModule/" + $scope.view.bookingId + "/" + paymentId + "/");
            $("#i-form").submit();
            $window.FLoading({ vAction: 'hide' });
        };

        //*************************Post Option Vale: Confirm **********************************
        $scope.confirmOption = function () {
            $scope.optionValue = { status: 0, bookingId: $scope.view.bookingId };
            $window.XLConfirm({
                vTitle: getT('airbooking.b2b.option.confirm'),
                vText: getT('airbooking.b2b.option.confirmtext'),
                vTextNo: getT('airbooking.b2b.option.no'),
                vTextYes: getT('airbooking.b2b.option.yesconfirm'),
                fCallBackYes: function () {
                    $window.FLoading({ vAction: 'show' });
                    $http.post('/api/api/payment/ProcessOptionWithoutPayment', {
                        requestId: $scope.view.bookingAdditionalData.RequestId.value,
                        bookingId: $scope.view.bookingId
                    }).success(function (response) {
                        if (response) {
                            XLConfirm({
                                vHeader: getT('airbooking.b2b.option.confirmed'),
                                vFlag: 'checked',
                                vTitle: getT('airbooking.b2b.option.emailwillbesent'),
                                vHideNo: true,
                                vHideYes: true,
                                vProgress: true
                            });
                            setTimeout(function () {
                                window.location.reload();
                            }, 5000);
                        } else {
                            $window.XLConfirm({ vTitle: getT('airbooking.b2b.option.error'), vTextYes: 'OK', vHideNo: true });
                            setTimeout(function () {
                                window.location.reload();
                            }, 2000);
                        }
                    }).error(function () {
                        $window.FLoading({ vAction: 'hide' });
                        $window.XLConfirm({ vTitle: getT('airbooking.b2b.option.error'), vTextYes: 'OK', vHideNo: true });
                    });
                    
                

                    //apiClient.postOptionValue($scope.optionValue).success(function (data) {

                    //    //Successful
                    //    if (data == 0) {

                    //        //call lemmings
                    //        $http.post('/api/api/payment/handlecovidoptionbooking', {
                    //            requestId: $scope.view.bookingAdditionalData.RequestId.value,
                    //            bookingId: $scope.view.bookingId
                    //        }).then(function (response) {
                    //            //check response status
                    //            if (response.status === 200) {

                    //                XLConfirm({
                    //                    vHeader: getT('airbooking.b2b.option.confirmed'),
                    //                    vFlag: 'checked',
                    //                    vTitle: getT('airbooking.b2b.option.emailwillbesent'),
                    //                    vHideNo: true,
                    //                    vHideYes: true,
                    //                    vProgress: true
                    //                });
                    //                setTimeout(function () {
                    //                    window.location.reload();
                    //                }, 5000);
                    //            }
                    //        });
                    //    }

                    //    //Error
                    //    if (data == 1) {
                    //        $window.XLConfirm({ vTitle: getT('airbooking.b2b.option.error'), vTextYes: 'OK', vHideNo: true });
                    //        setTimeout(function () {
                    //            window.location.reload();
                    //        }, 2000);
                    //    }

                    //    //Option Already Confirmed
                    //    if (data == 2) {
                    //        XLConfirm({
                    //            vTitle: getT('airbooking.b2b.option.notapplied') + ' ' + getT('airbooking.b2b.option.alreadyconfirmed'),
                    //            vHideNo: true,
                    //            vHideYes: true,
                    //            vProgress: true
                    //        });
                    //        setTimeout(function () {
                    //            window.location.reload();
                    //        }, 5000);
                    //    }

                    //    //Option Already Canceled
                    //    if (data == 3) {
                    //        XLConfirm({
                    //            vTitle: getT('airbooking.b2b.option.notapplied') + ' ' + getT('airbooking.b2b.option.alreadycancelled'),
                    //            vHideNo: true,
                    //            vHideYes: true,
                    //            vProgress: true
                    //        });
                    //        setTimeout(function () {
                    //            window.location.reload();
                    //        }, 5000);
                    //    }
                    //    $window.FLoading({ vAction: 'hide' });
                    //}).error(function () {
                    //    $window.FLoading({ vAction: 'hide' });
                    //    $window.XLConfirm({ vTitle: getT('airbooking.b2b.option.error'), vTextYes: 'OK', vHideNo: true });
                    //});
                },
            });
        };

        //*************************Post Option Value: Cancel **********************************
        $scope.cancelOption = function () {
            $scope.optionValue = { status: 1, bookingId: $scope.view.bookingId };
            $window.XLConfirm({
                vTitle: getT('airbooking.b2b.option.confirmcancellation'),
                vTextNo: getT('airbooking.b2b.option.no'),
                vTextYes: getT('airbooking.b2b.option.yes'),
                fCallBackYes: function () {
                    $window.FLoading({ vAction: 'show' });
                    apiClient.postOptionValue($scope.optionValue).success(function (data) {

                        //Successful
                        if (data == 0) {
                            XLConfirm({
                                vTitle: getT('airbooking.b2b.option.cancellationconfirmed'),
                                vHideNo: true,
                                vHideYes: true,
                                vProgress: true
                            });
                            setTimeout(function () {
                                window.location.reload();
                            }, 2000);
                        }

                        //Error
                        if (data == 1) {
                            $window.XLConfirm({ vTitle: getT('airbooking.b2b.option.error'), vTextYes: 'OK', vHideNo: true });
                            setTimeout(function () {
                                window.location.reload();
                            }, 2000);
                        }

                        //Option Already Confirmed
                        if (data == 2) {
                            XLConfirm({
                                vTitle: getT('airbooking.b2b.option.notapplied') + ' ' + getT('airbooking.b2b.option.alreadyconfirmed'),
                                vHideNo: true,
                                vHideYes: true,
                                vProgress: true
                            });
                            setTimeout(function () {
                                window.location.reload();
                            }, 5000);
                        }

                        //Option Already Canceled
                        if (data == 3) {
                            XLConfirm({
                                vTitle: getT('airbooking.b2b.option.notapplied') + ' ' + getT('airbooking.b2b.option.alreadycancelled'),
                                vHideNo: true,
                                vHideYes: true,
                                vProgress: true
                            });
                            setTimeout(function () {
                                window.location.reload();
                            }, 5000);
                        }
                        $window.FLoading({ vAction: 'hide' });
                    }).error(function () {
                        $window.FLoading({ vAction: 'hide' });
                        $window.XLConfirm({ vTitle: getT('airbooking.b2b.option.error'), vTextYes: 'OK', vHideNo: true });
                    });
                }
            });
        };
        //***************************EndPost Option Value************************************************************************************

        apiClient.B2B.getAgents().success(function (data) {
            var agentsToSearch = data.agents;
            $scope.agentsToSearchCount = data.agents.length;

            agentsToSearch.each(function (agent) {
                agent.firstName = agent.firstName.toLowerCase().capitalize();
                agent.lastName = agent.lastName.toLowerCase().capitalize();
                agent.fullName = (agent.firstName + ' ' + agent.lastName).trim();
                if (agent.fullName === "")
                    agent.fullName = "(No Name)";
            });
            agentsToSearch = agentsToSearch.orderBy(function (item) { return item.fullName; });
            agentsToSearch.unshift({
                fullName: $i18next.t('b2baccountreservation.allvendors') + " ({0})".format($scope.agentsToSearchCount),
                agentId: 'null'
            });
            $scope.agentsToSearch = agentsToSearch;
        });

        //Get City Name or Iata
        $scope.getCityNameOrIata = function (airportIata) {
            if ($scope.view.airports[airportIata].cityIata) {
                if ($scope.view.cities[$scope.view.airports[airportIata].cityIata])
                    return $scope.view.cities[$scope.view.airports[airportIata].cityIata].name;
            }
            else {
                if ($scope.view.airports[airportIata].name)
                    return $scope.view.airports[airportIata].name;
                else
                    return airportIata;
            }
        };


        //Get Terminal name
        $scope.getTerminalDisplayName = function (airport, terminal) {
            if ($scope.view.airports && $scope.view.airports[airport]) {
                $scope.listTerminalsAux = $scope.view.airports[airport].terminal;
                if ($scope.listTerminalsAux) {
                    $scope.listTerminalsAux = $scope.listTerminalsAux.groupByKey('code');
                    if ($scope.listTerminalsAux[terminal])
                        return terminalDisplayName = $scope.listTerminalsAux[terminal].name;
                }
            }
        };

        //********************************Booking List*********************************************************
        $scope.bookingListRequest = {};
        $scope.bookingList = {};

        $scope.bindBookingList = function (data) {
            $("#list").removeClass("c-form-disabled");

            $scope.bookingList = data;

            if (data.status === 0) {
                if ($scope.bookingList.bookings != null) {
                    $scope.bookingList.bookings.each(function (item) {
                        var byPaxType = item.flightPassengers.groupByKey("paxType");

                        item.paxAmount = {};
                        if (byPaxType[0]) {
                            if (window.isArray(byPaxType[0])) item.paxAmount["ADT"] = byPaxType[0].length;
                            else item.paxAmount["ADT"] = 1;
                        }
                        else
                            item.paxAmount["ADT"] = 0;

                        if (byPaxType[1]) {
                            if (window.isArray(byPaxType[1])) item.paxAmount["CNN"] = byPaxType[1].length;
                            else item.paxAmount["CNN"] = 1;
                        }
                        else
                            item.paxAmount["CNN"] = 0;
                        if (byPaxType[2]) {
                            if (window.isArray(byPaxType[2])) item.paxAmount["INF"] = byPaxType[2].length;
                            else item.paxAmount["INF"] = 1;
                        }
                        else item.paxAmount["INF"] = 0;
                    });
                }
            }
            $window.FLoading({ vAction: 'hide' });
        };

        $scope.getBookingList = function () {
            $scope.bookingList = null;
            $("#list").addClass("c-form-disabled");
            $window.FLoading({ vAction: 'show' });

            var bookingRQ = {
                enterprise: $scope.loginInfo.EnterpriseReference,
                accountNumber: $scope.loginInfo.Client.AccountNumber,
                agentId: $scope.bookingListRequest.agentId,
                bookingFromDate: $scope.bookingListRequest.FromBookingDate,
                bookingToDate: $scope.bookingListRequest.ToBookingDate,
                departureFromDate: $scope.bookingListRequest.FromDepartureDate,
                departureToDate: $scope.bookingListRequest.ToDepartureDate,
                paxName: $scope.bookingListRequest.paxName,
                bookingNumber: $scope.bookingListRequest.BookingSearch,
                details: true   //false to speed up search but lose "accomodations" value
            };

            console.log(bookingRQ);

            $scope.ignoreProductType = !(typeof $scope.bookingListRequest.paxName === 'undefined' || $scope.bookingListRequest.paxName === '');

            apiClient.AIR.getBookingSearch(bookingRQ).success(function (data) {
                data.bookings = data.bookings.filter(function (d) { return /^\d+$/i.test(d.bookingNumber); });
                $scope.bindBookingList(data);
            });

        }.getBuffered(600);

        $scope.getBookingList();

        $scope.$watch('$viewContentLoaded', function () {
            $.getScript("/global/js/widgets/mrfly-widget-loader.js").done(function () { });
        });

        $scope.getBookingDetails = function (bookingId, hotelOnly) {
      
            $scope.hotelOnly = hotelOnly;

            $window.FLoading({ vAction: 'show' });
            apiClient.AIR.getBookingDetails([bookingId]).success(function (data) {

                if (data && data.status == 0) {
                    setTimeout(function () {
                        $window.scrollTo(0, 0);
                    }, 100);
                    $scope.showDetail = true;
                    $scope.view = airHelper.getViewForBookingDetailsEntityVersion2(data);

                    //sort paxes if first one is not an adult
                    if ($scope.view.paxes[0].paxType !== 0) {
                        $scope.view.paxes.reverse();
                    }

                    var booking = hotelOnly ? data.bookings[1] : data.bookings[0];

                    $scope.view.payments = booking.payments;

                    $scope.view.invoices = [];
                    apiClient.AIR.getInvoicesList(booking.bookingId).success(function (data) {
                        $scope.view.invoices = data.grep(function (i) { return i.number != null; });
                    });
                    apiClient.AIR.getETicketsList(booking.bookingId).success(function (data) {
                        $scope.view.etickets = data;
                    });

                    $window.Typescript.ETickets.Services.ETicketsService.getEticketsTrain(booking.bookingId, $scope.view.bookingNumber).then(function (axiosResponse) {
                        $scope.view.eticketstrain = axiosResponse.data;
                        $scope.$apply();
                    }, function (err) {

                    });
                    $scope.$broadcast("onBookingSummaryUpdate");
                    $scope.pendingPayment = $scope.view.payments && $scope.view.payments.any(function (payment) { return (payment.status == 0); });
                    $scope.isCrossFaring = $scope.view._innerData.bookings[0] && $scope.view._innerData.bookings[0].pnrs.length > 1;
                    $scope.isProductTO = $scope.view.itineraries[0].productType == 1;

                    if ($scope.view.status == 4 && $scope.view.option && $scope.view.option.status == 0) {
                        $scope.lastTicketing = moment(($scope.view.option.lastTicketing), 'YYYY/MM/DD').toDate();
                    }

                    //Insurances
                    if ($scope.view.insurances) {
                        $scope.view.insurances.each(function (insurance) {
                            if (insurance.companyReference == 2 && insurance.insuranceReference == 2)
                                insurance.displayName = $i18next.t('airbooking.insurance.multipleriskspack');
                            else
                                insurance.displayName = insurance.insuranceName;
                        });
                    }


                    //accommodation
                    if (booking.accommodations && booking.accommodations.any()) {
                        $scope.view.showaccomodationinfo = true;

                        $scope.view.bookingRef = booking.accommodations[0].bookingRef;
                        $scope.view.voucherUri = booking.accommodations[0].voucherUri;

                        //replace flight info by hotel info
                        if (hotelOnly) {

                            $scope.view.status = booking.status;
                            $scope.view.bookingNumber = booking.bookingNumber;
                            $scope.view.fares.items = booking.fares;
                            $scope.view.accommodation = booking.accommodations[0];

                            var hotelMargin = 0;

                            $scope.view.fares.items.each(function (fare) {
                                if (fare.type === 70 && fare.subtype === 901) {
                                    fare.name = $i18next.t('airbooking.hotelcommission');
                                    hotelMargin += parseFloat(fare.amount);
                                }
                                if (fare.type === 11 && fare.subtype === 100) {
                                    fare.name = $i18next.t('mrfly-widget-accommodation-price-detail.hotelamount');
                                }
                            });

                            var total = parseFloat(booking.accommodations[0].totalPriceForcedPrice) + hotelMargin;
                            var int = Math.floor(total);
                            var fixed = total.toFixed(2).toString();
                            var dec = fixed.substring(fixed.length - 2, fixed.length);
                            $scope.view.fares.total.int = int;
                            $scope.view.fares.total.dec = dec;
                        }

                        $.getScript("/Global/js/widgets/mrfly-widget-accommodation-info.js").done(function () {

                            mrflyWidgets['mrfly-widget-accommodation-info'].locale = $window.lng.substring(0, 2);
                            mrflyWidgets['mrfly-widget-accommodation-info'].resources = i18next.store.data.dev.translation;
                            mrflyWidgets['mrfly-widget-accommodation-info'].accommodation = booking.accommodations[0];
                            mrflyWidgets['mrfly-widget-accommodation-info'].siteType = window.site.type;

                            var margin = booking.fares.filter(function (f) { return f.type === 70 && f.subtype === 901; });
                            if (margin.length > 0) {
                                mrflyWidgets['mrfly-widget-accommodation-info'].agencyMarginHotel = margin[0].amount;
                            }
                        });
                    }


                    //on n'autorise l'ajout que pour les booking confirmé et inprogress et qui ont leur date de retour qui n'est pas passé (ou aller si aller simple) 
                    $scope.allowAddSpecialRequest = false;
                  
                    if (($scope.view.status == 2 || $scope.view.status == 1) && $scope.view.subStatus != 2) {
                        if ($scope.view.request.oneWay) {
                            $scope.allowAddSpecialRequest = moment($scope.view.request.goDate.date) > Date.now();
                        }
                        if ($scope.view.request.roundTrip) {
                            $scope.allowAddSpecialRequest = moment($scope.view.request.goDate2.date) > Date.now();
                        }
                    }

                    if (!$scope.hideSpecialRequest && $scope.allowAddSpecialRequest) {

                        //wait until div visible to load js 
                        var loadSpecialRequestOnReady = setInterval(function () {
                            if ($('.special-request-component').length > 0) {
                                $.getScript("/global/js/widgets/mrfly-widget-special-request.js").done(function () {

                                }).fail(function (jqxhr, settings, exception) {
                                    console.log(exception);
                                });
                                clearInterval(loadSpecialRequestOnReady);
                            }
                        }, 200); // check every 200ms

                    }

                    if (!hotelOnly) {

                        $.getScript("/Global/js/widgets/mrfly-widget-request-recap.js").done(function () {
                            console.log("Loading done");
                            //set params do mapping

                            var airSearchRequest = new window['Typescript']['Class']['AirSearchRequest']['AirSearchRequest']();

                            airSearchRequest.adultNumber = $scope.view.request.adults;
                            airSearchRequest.childNumber = $scope.view.request.childs;
                            airSearchRequest.infantNumber = $scope.view.request.infants;
                            airSearchRequest.isOneWay = $scope.view.request.oneWay;
                            airSearchRequest.isRoundTrip = $scope.view.request.roundTrip;
                            airSearchRequest.isOpenJaw = $scope.view.request.openJaw;
                            airSearchRequest.isMultiDestination = $scope.view.request.multi;

                            //Map itineraries
                            airSearchRequest.itineraries = [];
                            $scope.view.itineraries.forEach(function (itinerary) {
                                var ins = new window['Typescript']['Class']['AirSearchRequest']['AirSearchRequestItinerary']();

                                ins.date = itinerary.departureDate;

                                ins.departureAirportIata = itinerary.departure;
                                ins.departureCityIata = itinerary.origin;
                                ins.departureName = $scope.getCityNameOrIata(itinerary.departure);

                                ins.arrivalAirportIata = itinerary.arrival;
                                ins.arrivalCityIata = itinerary.destination;
                                ins.arrivalName = $scope.getCityNameOrIata(itinerary.arrival);

                                airSearchRequest.itineraries.push(ins);
                            });
                            mrflyWidgets['mrfly-widget-request-recap'].airSearchRequest = airSearchRequest;
                            mrflyWidgets['mrfly-widget-request-recap'].locale = $window.lng.substring(0, 2);
                            mrflyWidgets['mrfly-widget-request-recap'].language = $window.lng;
                            mrflyWidgets['mrfly-widget-request-recap'].resources = i18next.store.data.dev.translation;
                        });
                    }

                    //Start here: branded fares
                    $scope.hasBrandedFare = $scope.view &&
                        $scope.view._innerData.bookings[0] &&
                        $scope.view._innerData.bookings[0].pnrs &&
                        $scope.view._innerData.bookings[0].pnrs.any(function (item) {
                            if (item.brand && item.brand.brandServices && item.brand.brandServices.length > 0)
                                return true;
                        });

                    if ($scope.hasBrandedFare) {
                        $scope.brand = $scope.view._innerData.bookings[0].pnrs[0].brand;
                        if ($scope.brand) {
                            $scope.brand.displayName = $scope.brand.displayName.capitalize();
                            $scope.brand.includedServices = [];
                            $scope.brand.brandServices.each(function (bService) {
                                if (bService.pricing == 0) {
                                    if (bService.description != null && bService.description != undefined)
                                        bService.descriptionHtml = bService.description.replaceAll("\n", "<br/>");

                                    bService.cssClass =
                                        (bService.rficGroup + (bService.rficSubGroup ? "-" + bService.rficSubGroup : ""))
                                            .toLowerCase();
                                    $scope.brand.includedServices.push(bService);
                                }
                            });
                        }


                        $scope.hasIncludedBaggage = $scope.view.itineraries[0] &&
                            $scope.view.itineraries[0].baggages[0]
                            && $scope.view.itineraries[0].baggages[0].quantity > 0;
                    }
                    //End here

                    $window.FLoading({ vAction: 'hide' });
                    $("#list").removeClass("c-form-disabled");
                }
                else
                    console.log("no data");
            });
        };

        $scope.getInvoiceDownloadLink = function (invoiceId, forceDownload, bookingNumber) {
            return apiClient.AIR.getInvoiceDownloadLink(invoiceId, forceDownload, bookingNumber);
        };

        $scope.getETicketDownloadLink = function (invoiceId, forceDownload, bookingNumber) {
            return apiClient.AIR.getETicketDownloadLink(invoiceId, forceDownload, bookingNumber);
        };

        $scope.exportExcel = function () {
            var url = apiClient.AIR.getBookingListExportLink($scope.bookingListRequest);
            $window.location.href = url;
        };

        $scope.returnToList = function () {
            $scope.showDetail = false;
        };
        $scope.callDrop = function (_event, type) {
            var varIsCountry = (type == 'country') ? 1 : 0;
            var name = 'i-' + type;
            var value = $("#ul-" + type).get(0);
            FSelect({ e: _event, myObj: value, vName: name, isCountry: varIsCountry });
            if (type == 'date') {
                $scope.updateDates();
            }
            $scope.getBookingList();
        };
        $scope.updateDates = function () {
            $scope.bookingListRequest.FromDepartureDate = null;
            $scope.bookingListRequest.ToDepartureDate = null;
            $scope.bookingListRequest.FromBookingDate = null;
            $scope.bookingListRequest.ToBookingDate = null;
            var from = moment($scope.bookingRequest.fromDate, 'DD/MM/YYYY');
            var to = moment($scope.bookingRequest.toDate, 'DD/MM/YYYY');

            if ($scope.dateType == 1) {
                $scope.bookingListRequest.FromBookingDate = from.isValid() ? from.format('YYYY-MM-DD') : '1970-01-01';
                // add one day since date filter is < and not <=
                $scope.bookingListRequest.ToBookingDate = to.isValid() ? to.add(1, 'days').format('YYYY-MM-DD') : '2270-01-01';
            }
            else {
                $scope.bookingListRequest.FromDepartureDate = from.isValid() ? from.format('YYYY-MM-DD') : '1970-01-01';
                // add one day since date filter is < and not <=
                $scope.bookingListRequest.ToDepartureDate = to.isValid() ? to.add(1, 'days').format('YYYY-MM-DD') : '2270-01-01';
            }
        };

        //**************************
        $scope.sendReceiptShow = function (index) {
            var value = $("#i-payment-receipt-" + index).get(0);
            FPop({ oTarget: value, iPop: 'i-receipt-pop-' + index, vStyle: 'classic' });
        };
        $scope.sendReceipt = function (payment, index) {
            if (XLFormValid({ iCont: 'i-form-receipt-' + index })) {
                var pId = payment.paymentId;
                var pspId = payment.bankCards[0].paymentPspId;
                var bId = $scope.view.bookingId;
                var bNum = $scope.view.bookingNumber;
                var to = $("#i-receipt-email-" + index).val();
                var mail = { bookingId: bId, bookingNumber: bNum, paymentId: pId, paymentPspId: pspId, addressTo: to, type: "ReceiptOfPayment" };

                var okMSG = function () { XLConfirm({ vTitle: geT('airbooking.b2b.option.emailsent'), vTextYes: 'OK', vHideNo: true }); };
                var failMSG = function () { XLConfirm({ vTitle: getT('airbooking.b2b.option.emailerror'), vTextYes: 'OK', vHideNo: true }); };

                apiClient.sendMail(mail).success(function (response) {
                    if (response) okMSG();
                    else failMSG();
                    $("#i-receipt-email-" + index).val('');
                }).error(function () { failMSG(); });


                FPopHide({ iPop: 'i-receipt-pop-' + index });
            }
        };
        //**************************
        $scope.sendEticketShow = function () {
            var value = $("#i-eticket").get(0);
            FPop({ oTarget: value, iPop: 'i-eticket-pop', vStyle: 'classic' });
        };
        $scope.sendEticket = function () {
            if (XLFormValid({ iCont: 'i-form-eticket' })) {
                var bId = $scope.view.bookingId;
                var bNum = $scope.view.bookingNumber;
                var to = $("#i-eticket-email").val();
                var mail = { bookingId: bId, bookingNumber: bNum, addressTo: to, type: "ETicket" };

                var okMSG = function () { XLConfirm({ vTitle: geT('airbooking.b2b.option.emailsent'), vTextYes: 'OK', vHideNo: true }); };
                var failMSG = function () { XLConfirm({ vTitle: getT('airbooking.b2b.option.emailerror'), vTextYes: 'OK', vHideNo: true }); };

                apiClient.sendMail(mail).success(function (response) {
                    if (response) okMSG();
                    else failMSG();
                    $("#i-eticket-email").val('');
                }).error(function () { failMSG(); });

                FPopHide({ iPop: 'i-eticket-pop' });
            }
        };
        //**************************
        $scope.clearFilters = function () {
            $scope.bookingListRequest = {};
            $scope.bookingRequest = {};
        };

        $scope.searchBookings = function () {
            $scope.updateDates();
            $scope.getBookingList();
        };

        $scope.selectProductType = function (type) {
            $scope.productType = type;
            $window.sessionStorage.setItem('selectedProductType', type);
        };

        //**************************

        //This is only for debug
        $window.$scope = $scope;
        $window.$scope.apiClient = apiClient;

        $scope.loadBookingDetails = function (hash) {
            var m = hash.match(/([^#$]+)(?:#([^#$]+))?/i);
            var detail = m[1];
            var type = m.length > 1 ? m[2] : null;
            var hotelOnly = type && type.toUpperCase() === 'H';
            $scope.getBookingDetails(detail, hotelOnly);
            $window.sendAnalytics('/Mybookings/View', 'Booking view');
            $window.sendInspectlet("pageUrl", $window.getUrl('Mybookings/View'));
        };

        //************************************************************************************************************************
        //OnLoad
        if (window.location.hash !== "") {
            $scope.updateDates();// set default values to avoid timeout
            $scope.loadBookingDetails(window.location.hash);
        }
        else {
            $scope.updateDates();
            $scope.getBookingList();
            $window.sendAnalytics('/Mybookings/', 'List of booking');
            $window.sendInspectlet("pageUrl", $window.getUrl('Mybookings/'));
        }

        //Detect if hash changes.
        var hashChanged = function (callback) {
            var lastHash = window.location.hash;
            var innerFunc = function () {
                if (window.location.hash != lastHash) {
                    lastHash = window.location.hash;
                    if (callback)
                        callback(lastHash);
                }
                setTimeout(innerFunc, 100);
            };
            setTimeout(innerFunc, 100);
        };
        hashChanged(function (hashValue) {
            if (hashValue === "" || window.location.hash === "#") {
                $scope.showDetail = false;
                $scope.$apply(function () {
                    setTimeout(function () {
                        $window.scrollTo(0, 0);
                        $("#list").removeClass("c-form-disabled");
                    }, 100);
                });
                $window.sendAnalytics('/Mybookings/', 'List of booking');
                $window.sendInspectlet("pageUrl", $window.getUrl('Mybookings/'));
            }
            else {
                $scope.loadBookingDetails(window.location.hash);
            }
        });

        //GoToContactForm
        //@desc this function build the url to pass to contact form with the customer data
        $scope.goToContactForm = function () {
            var contactUrl = "../contact/nous-contacter/";
            if ($scope.view.bookingNumber)
                contactUrl = "../contact/nous-contacter/" + $scope.view.bookingNumber;

            //Check agent information to autofill fields in contact form
            if ($scope.loginInfo && $scope.loginInfo.Agent && $scope.loginInfo.Agent.FirstName
                && $scope.loginInfo.Agent.LastName && $scope.loginInfo.Agent.LastName && $scope.loginInfo.Agent.Account) {
                contactUrl = "../contact/nous-contacter/" +
                    $scope.view.bookingNumber + "/" +
                    $scope.loginInfo.Agent.FirstName + "/" +
                    $scope.loginInfo.Agent.LastName + "/" +
                    $scope.loginInfo.Agent.Account;
            }
            window.location.href = contactUrl;
        };
        //************************************************************************************************************************

        //Open the modal with the key provided
        $scope.openModal = function (key) {
            if (key) {
                $timeout(function () {
                    $('[data-remodal-id=' + key + ']').remodal().open();
                },
                    200,
                    false);
            }
        };

        // Prepare the object to display in the Taxes Modal
        $scope.prepareTaxesDetailModal = function (key, paxType, fareItem, quantity) {
            $scope.displayTaxesDetailModal = false;
            if (fareItem) {

                var faresTaxes = airHelper.prepareTaxesObjectForBkgDetails(fareItem);

                if (faresTaxes) {

                    var taxesDetailsObject = {
                        paxtype: paxType,
                        key: key,
                        paxnumber: quantity,
                        fares: faresTaxes
                    };

                    $scope.modalTaxesKey = taxesDetailsObject.key;
                    $scope.modalTaxesPaxType = taxesDetailsObject.paxtype;
                    $scope.modalTaxesPaxFares = taxesDetailsObject.fares;
                    $scope.modalTaxesPaxNumber = taxesDetailsObject.paxnumber;

                    $scope.$broadcast("updateTaxesDetailModalData",
                        {
                            key: $scope.modalTaxesKey,
                            paxType: $scope.modalTaxesPaxType,
                            fares: $scope.modalTaxesPaxFares,
                            paxnumber: $scope.modalPaxNumber
                        });

                    $scope.displayTaxesDetailModal = true;

                    $scope.openModal('taxes-detail-modal-' + $scope.modalTaxesKey + '-' + $scope.modalTaxesPaxType);

                } else
                    return;
            }
        };

        $scope.getInsurancePdf = function (insurance) {
            if ((insurance.companyReference === '00001' || insurance.companyReference === '00002') && insurance.insuranceReference === '00001') {
                return $window.getUrl('page/pdfviewer?pdfname=conditionsassuranceannulation');
            }
            else if ((insurance.companyReference === '00001' || insurance.companyReference === '00002') && insurance.insuranceReference === '00002') {
                return $window.getUrl('page/pdfviewer?pdfname=detailsgarantimultiinsurance');
            }
            else if ((insurance.companyReference === '00001' || insurance.companyReference === '00002') && insurance.insuranceReference === '00003') {
                return $window.getUrl('page/pdfviewer?pdfname=conditionsassurancerapatriement');
            }
            else if ((insurance.companyReference === '00001' || insurance.companyReference === '00002') && insurance.insuranceReference === '00004') {
                return $window.getUrl('page/pdfviewer?pdfname=conditionsassurancerapatriement_0004');
            }
            else
                return null;
        };

        $scope.getInsuranceName = function (insurance) {
            if ((insurance.companyReference === '00001' || insurance.companyReference === '00002') &&
                (insurance.insuranceReference === '00004' || insurance.insuranceReference === '00004')) {
                return $i18next.t('mrfly-widget-insurance-payment.subtitle');
            }
            else
                return insurance.displayName;
        };

        $scope.getInsuranceContractNumber = function (insurance) {
            if (insurance.companyReference === '00002' && insurance.insuranceReference === '00001') {
                return 'AX2016061';
            }
            else if (insurance.companyReference === '00002' && insurance.insuranceReference === '00002') {
                return 'AX2016060';
            }
            else if (insurance.companyReference === '00002' && insurance.insuranceReference === '00003') {
                return 'AX2016062';
            }
            else if (insurance.companyReference === '00002' && insurance.insuranceReference === '00004') {
                return 'AX2019216';
            }
            if (insurance.companyReference === '00001' && insurance.insuranceReference === '00001') {
                return '7 906 155';
            }
            else if (insurance.companyReference === '00001' && insurance.insuranceReference === '00002') {
                return '7 906 157';
            }
            else if (insurance.companyReference === '00001' && insurance.insuranceReference === '00003') {
                return '7 906 156';
            }
            else
                return null;
        };
    }]);